import VibrateBase from "./vibrate.base";

export default class VibrateWeb extends VibrateBase {
  
  constructor() {
    super();
  }

  public override async vibrate(pattern: number | number[]): Promise<boolean> {
    if (navigator?.vibrate === undefined) {
      return false;
    }
    return navigator.vibrate(pattern);
  }
}